const BASE_URL = 'https://server.zymls.com/website';
// const BASE_URL = 'https://test.zymls.com/website';
// const BASE_URL = 'http://192.168.108.93:8888/website';

const WEBSITE_URL_OBJECT = {
    map:BASE_URL + '/showpage/storeMap',//current=1&size=10
    news: BASE_URL + '/newscontent/page',//newsType=1&current=1&size=6
    feedback:BASE_URL + '/feedback',//{"contactName":"1","email":"1","contactPhone":"1","content":"3"}
    osconfig:BASE_URL + '/osconfig/get',
    getCooperateList:BASE_URL + '/joinpage/getCooperateList',
    getOpenArea:BASE_URL + '/joinpage/getOpenArea'
}
export default WEBSITE_URL_OBJECT;


// WEBPACK FOOTER //
// ./src/api/index.js